import { defineStore } from 'pinia';
import { storage } from '@/firebase';
import { ref as storageRef, uploadBytes, getDownloadURL, deleteObject } from 'firebase/storage';
import { useAuthStore } from '@/store/authstore';

export const useFilesStore = defineStore('files', {
    actions: {
        async uploadInvoiceLogo(file: File, invoiceId: string): Promise<string | null> {
            const authStore = useAuthStore();
            if (!authStore.user?.uid) return null;

            const userId = authStore.user.uid;
            const fileRef = storageRef(storage, `users/${userId}/invoices/${invoiceId}/logo.png`);
            await uploadBytes(fileRef, file);
            const url = await getDownloadURL(fileRef);

            return url;
        },

        async deleteInvoiceLogo(invoiceId: string): Promise<void> {
            const authStore = useAuthStore();
            if (!authStore.user?.uid) return;

            const userId = authStore.user.uid;
            const fileRef = storageRef(storage, `users/${userId}/invoices/${invoiceId}/logo.png`);
            try {
                await deleteObject(fileRef);
            } catch (err: any) {
                console.warn('deleteInvoiceLogo: could not delete logo.png', err?.code || err?.message || err);
            }
        }
        ,
        async uploadDefaultLogo(file: File): Promise<string | null> {
            const authStore = useAuthStore();
            if (!authStore.user?.uid) return null;

            const userId = authStore.user.uid;
            const fileRef = storageRef(storage, `users/${userId}/settings/defaultLogo.png`);
            await uploadBytes(fileRef, file);
            const url = await getDownloadURL(fileRef);
            return url;
        },

        async uploadExpenseReceipt(file: File, expenseId: string): Promise<string | null> {
            const authStore = useAuthStore();
            if (!authStore.user?.uid) return null;

            const userId = authStore.user.uid;
            const ext = file.name.split('.').pop() || 'jpg';
            const fileRef = storageRef(storage, `users/${userId}/expenses/${expenseId}/receipt.${ext}`);
            await uploadBytes(fileRef, file);
            const url = await getDownloadURL(fileRef);
            return url;
        },

        async deleteExpenseReceipt(expenseId: string): Promise<void> {
            const authStore = useAuthStore();
            if (!authStore.user?.uid) return;

            const userId = authStore.user.uid;
            const extensions = ['jpg', 'jpeg', 'png', 'pdf', 'webp'];
            for (const ext of extensions) {
                try {
                    const fileRef = storageRef(storage, `users/${userId}/expenses/${expenseId}/receipt.${ext}`);
                    await deleteObject(fileRef);
                    return;
                } catch {
                    // try next extension
                }
            }
        }
    }
});
